import {
    put, takeLatest, call
} from 'redux-saga/effects';
import { authenticatedAxios } from '../client';
import {
    UPDATE_ACCOUNT, UPDATE_DETAILED_PROFILE_FORM_VIEWED,
    updateAccount,
    UPDATE_PROFILE_IMAGE, updateProfileImage,
    updateDetailedProfileFormViewedSuccess,
    updateDetailedProfileFormViewedFailure, GET_REDEMPTION_ACCOUNTS,
    getRedemptionAccounts, GET_REDEMPTION_ACCOUNT_TOKEN,
    GET_ACCOUNT, getAccount,
    getRedemptionAccountToken
} from "../actions/user";

function* handleUpdateProfileImage({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        yield call(authenticatedAxios.post,
            `${window.api_url}/site-secure/account/${payload.accountId}/update-profile`,
            {
                image: payload.image,
                first_name: payload.firstName,
                last_name: payload.lastName,
                email: payload.email
            }
        );
    } catch (error) {
        yield put(updateProfileImage(error, {}, true));
    }
    yield put(updateProfileImage({}, {'sent': true}));
}
export function* watchUpdateProfileImage() {
    yield takeLatest(UPDATE_PROFILE_IMAGE, handleUpdateProfileImage);
}






function* handleUpdateAccount({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    let photoUrlResponse = null;
    let photoUrl = null;
    let response;

    if (payload.photo) {
        try {
            const params = new URLSearchParams();
            params.append('image', payload.photo);
            photoUrlResponse = yield call(authenticatedAxios.post,
                `${window.react_giftya_base_url}/img/send-to-s3`,
                params
            );
            photoUrl = photoUrlResponse.data.url;
        } catch (error) {
            yield put(updateAccount(error, {}, true));
            return;
        }
    }

    try {
        response = yield call(authenticatedAxios.post,
            `${window.api_url}/site-secure/account/${payload.accountId}/update-profile`,
            {
                'first_name': payload.firstName,
                'last_name': payload.lastName,
                'email': payload.email,
                'image': photoUrl,
                'agreed_to_terms': payload.agreedToTerms
            }
        );
        // console.log(response);
    } catch (error) {
        yield put(updateAccount(error, {}, true));
    }
    yield put(updateAccount(response.data, {'sent': true}));
}
export function* watchUpdateAccount() {
    yield takeLatest(UPDATE_ACCOUNT, handleUpdateAccount);
}


function* handleUpdateDetailedProfileFormViewed(action) {
    try {
        yield call(authenticatedAxios.post,
            `${window.api_url}/site-secure/account/${action.accountId}/set-detailed-profile-form-viewed`
        );
        yield put(updateDetailedProfileFormViewedSuccess());
    } catch (e) {
        yield put(updateDetailedProfileFormViewedFailure());
    }
}
export function* watchUpdateDetailedProfileFormViewed() {
    yield takeLatest(UPDATE_DETAILED_PROFILE_FORM_VIEWED, handleUpdateDetailedProfileFormViewed);
}



function* handleGetRedemptionAccounts({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(authenticatedAxios.get,
            `${window.api_url}/accounts/${payload.accountId}/redemption-methods`
        );

        yield put(getRedemptionAccounts({
            redemptionAccounts: response.data
        }, {'sent': true}));

    } catch (error) {
        yield put(getRedemptionAccounts(error, {}, true));
    }
}
export function* watchGetRedemptionAccounts() {
    yield takeLatest(GET_REDEMPTION_ACCOUNTS, handleGetRedemptionAccounts);
}


function* handleGetAccount({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(authenticatedAxios.get,
            `${window.api_url}/site-secure/account/${payload.accountId}`
        );

        yield put(getAccount(response.data, {'sent': true}));

    } catch (error) {
        yield put(getAccount(error, {}, true));
    }
}
export function* watchGetAccount() {
    yield takeLatest(GET_ACCOUNT, handleGetAccount);
}


function* handleGetRedemptionAccountToken({payload, meta, error}) {
    if (error || (meta && meta.sent === true)) {
        return;
    }

    try {
        const response = yield call(authenticatedAxios.get,
            `${window.api_url}/redemption-methods/${payload.redemptionAccountId}/token`
        );

        yield put(getRedemptionAccountToken({
            redemptionAccountToken: response.data
        }, {'sent': true}));

    } catch (error) {
        yield put(getRedemptionAccountToken(error, {}, true));
    }
}
export function* watchGetRedemptionAccountToken() {
    yield takeLatest(GET_REDEMPTION_ACCOUNT_TOKEN, handleGetRedemptionAccountToken);
}